import { Button, Grid, Typography, Avatar, Tooltip, Box, useMediaQuery } from "@mui/material";
import PropTypes from "prop-types";
import Iconify from "../../../../reusable-components/iconify";

NewDialogButton.propTypes = {
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  buttonDescription: PropTypes.string,
  buttonLabel: PropTypes.string,
  tooltipText: PropTypes.string,
  icon: PropTypes.string,
}
export default function NewDialogButton({handleClick, disabled, sx, buttonDescription, buttonLabel, tooltipText, icon}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Grid item xs={12} sm={6} width={"100%"}>
      <Tooltip arrow placement="top" title={tooltipText} >
        <Box sx={{ boxShadow: 3 }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={handleClick}
            disableRipple={disabled}
            disabled={disabled}
            sx={sx}
          >
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
              <Grid item style={{ paddingTop: 15 }} xs={'auto'} sm={12} justifyItems={'center'}>
                <Avatar
                  sx={{
                    height: isMobile ? 30 : 60,
                    minWidth: isMobile ? 30 : 60,
                    width: isMobile ? 30 : 60,
                    backgroundColor: '#fff',
                    border: '1px solid #4ca5e7',
                  }}
                >
                  <Iconify
                    icon={icon}
                    height={isMobile ? 20 : 40}
                    width={isMobile ? 20 : 40}
                    style={{ color: '#4ca5e7' }}
                  />
                </Avatar>
              </Grid>
              <Grid item xs={'auto'} sm={12}>
                <Typography variant="subtitle1" color="#4ca5e7" sx={{pt: isMobile ? 1 : 0}}>
                  {buttonLabel}
                </Typography>
              </Grid>
              <Grid item sx={{ pb: 2 }} xs={12}>
                <Typography variant="subtitle2" color="#4ca5e7">
                  {buttonDescription}
                </Typography>
              </Grid>
            </Grid>
          </Button>
        </Box>
      </Tooltip>
    </Grid>
  );
}